import Typography from '@components/Typography';

import { Header, ContentWrapper, Container } from './styled';

const BasePage = ({
  title,
  children,
}: React.PropsWithChildren<{ title?: string }>) => {
  return (
    <Container>
      {title ? (
        <Header>
          <Typography variant='Title2' color='D400' weight='SemiBold'>
            {title}
          </Typography>
        </Header>
      ) : null}
      <ContentWrapper>{children}</ContentWrapper>
    </Container>
  );
};

export default BasePage;
